<template>
    <div class="install-cert-modal">
        <div class="header">
            <div class="title">Для стабильной работы потребуются сертификаты Минцифры</div>
            <div class="close" @click="saveAndClose"></div>
        </div>
        <div class="content">Установите российские сертификаты для стабильного доступа к порталу</div>

        <div class="buttons">
            <div class="left">
                <router-link :to="{ name: 'install-certificates' }"
                             class="primary action"
                             tag="button"
                             @click.native="saveAndClose">
                    <span class="text">Подробнее</span>
                </router-link>
            </div>
            <div class="right">
                <Checkbox v-model="noMore">Больше не показывать</Checkbox>
            </div>
        </div>
    </div>
</template>

<script>
import { Popup } from '@dsee/components/popups/popup';
import { local, session } from '@dsee/util/storage';


const INSTALL_CERT_NO_MORE = 'INSTALL_CERT_NO_MORE';

export default {
    name: 'InstallCertModal',
    data() {
        return {
            noMore: false,
        };
    },
    mounted() {
        this.$modal = new Popup({
            removeOnClose: true,
        }, this.$el);

        const noShow = local.get(INSTALL_CERT_NO_MORE, false) || session.get(INSTALL_CERT_NO_MORE, false);

        if (noShow) {
            this.noMore = true;
            this.$destroy();
            return;
        }

        this.open();
    },
    methods: {
        open() {
            this.$modal.open();
        },
        close() {
            this.$modal.close();
        },
        save() {
            if (!this.noMore) {
                session.put(INSTALL_CERT_NO_MORE, true);
            } else {
                local.put(INSTALL_CERT_NO_MORE, true);
            }
        },
        saveAndClose() {
            this.save();
            this.close();
        },
    },
};
</script>

<style lang="scss" scoped>
.install-cert-modal {
    max-width: 500px;
    width: 100%;

    .buttons {
        justify-content: space-between;

        .action {
            &:not(:last-child) {
                margin-right: 8px;
            }
        }
    }
}
</style>
